import { Table } from "antd";
import BaseComponent from "../../../../base/common/BaseComponent";
import "../../../../app/commonComponents/listTable/antTableCustom.scss";
class ShareTaskTable extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    const { data, columns, tableKey, className } = this.props;

    return (
      <div>
        <Table
          key={tableKey}
          className={`antTable ${className}`}
          columns={columns}
          rowKey={this._generateGUID()}
          dataSource={data}
          pagination={false}
          rowClassName={(record) => (record.isCurrentTask ? "bold" : "")}
          scroll={this.props.scroll}
        />
      </div>
    );
  }
}

export default ShareTaskTable;
